module.exports = __webpack_public_path__ + "static/media/inventory_icon.d8eddaf0.svg";